import React from 'react'
import { useTheme } from 'styled-components'
import { useMediaQuery } from '../../core/application/hooks'
import { deviceSizes } from '../../core/application/theme/breakpoints'


const LeftArrowIcon: React.FC = () => {

  const isMobile = useMediaQuery(parseInt(deviceSizes.tablet))
  const { color } = useTheme()
  const fillColor = isMobile ? color.black : color.iconGray

  return <svg width='21' height='21' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M16 7H3.83L9.42 1.41L8 0L0 8L8 16L9.41 14.59L3.83 9H16V7Z' fill={fillColor} />
  </svg>


}

export default LeftArrowIcon
